
import CommonUtils from "@/common-utils";
import BottomSheets from "@/components/BottomSheets.vue";
import { NotificationSettingVO } from "@/views/biz-kr/mypage/vo/mypage.vo";
import axios from "axios";
import debounce from "lodash-es/debounce";
import { DateTime } from "luxon";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RaffleMasterVO, RaffleProductVO, RaffleTicketVO } from "./vo/raffle.vo";

@Component({
  components: { BottomSheets },
})
export default class Raffles extends Vue {
  @Prop()
  viewType!: string;

  searchParams = { searchViewType: this.viewType ? "04" : "01", raffleCd: 0 };

  // searchParams = { searchViewType: "01", raffleCd: 0 };
  raffle = {} as RaffleMasterVO;
  products = [] as Array<RaffleProductVO>;
  tickets = [] as Array<RaffleTicketVO>;
  raffleNotificationState = {} as NotificationSettingVO;
  myMemCd = 0;

  remainingTimeInterval;
  remainingTime = "";
  // 1: 하루 이상 남음, 2: 하루 미만 남음, 0: 종료
  remainingTimeStatus = 99;

  dynamicLinksRaw; // 다이나믹링크

  noticePop = false;

  // 메인임?
  get isMain() {
    return this.$route.name === "Main";
  }

  get ticketCount() {
    return this.tickets.length;
  }

  // 공유 링크
  get sharedUrl(): string {
    return `${process.env.VUE_APP_MAIN_URL}raffles?refId=${this.raffle.memId}&refMemCd=${this.raffle.memCd}`;
  }

  @Watch("searchParams.searchViewType")
  onChangeSearchOption() {
    this.searchProduct();
  }

  // 응모하기
  async onRaffle(product: RaffleProductVO) {
    if (process.env.NODE_ENV == "production" && CommonUtils.isApp() == false) {
      // 모바일 웹
      if (confirm(this.$t("common.c0007").toString())) {
        // APP에서만 이용할 수 있는 서비스입니다.\nAPP으로 이동하시겠습니까?
        if (this.$isMobile) {
          // this.createDynamicLinks().then((r) => {
          //   location.href = r;
            
          // });
          location.href = `${process.env.VUE_APP_MAIN_URL}zlink?target=raffles`
        } else {
          //pc에서 재입고알림 누를 시
          location.href = "https://www.zikoo.kr/";
        }
        return;
      }
      // 앱에서만 이용 가능합니다.
      // alert(this.$t("raffle.a0006"));
      return;
    }

    // 로그인 체크하고
    CommonUtils.checkLoginStatus(this).then((r) => {
      if (!this.tickets.length) {
        // 응모권이 없습니다.
        alert(this.$t("raffle.a0005"));
        return;
      }

      // 노실명인증이면(아이폰)
      if (r.hasRealName == false) {
        // 당첨자 발표를 위해 전화번호 인증이 필요합니다. 이동하시겠습니까?
        if (confirm(this.$t("raffle.c0003").toString()) == false) {
          return;
        }

        // PC면 새창
        if(this.$isMobile == false) {
          window.open(`${CommonUtils.createStaticUrl(this, 'RealNameForm' )}?nextRouteName=MemberInfo`, "_blank", "width=762, height=800")
          return;
        } 

        this.$router.push({ name: "RealNameForm", params: { nextRouteName: "MemberInfo" } });
        return;
      }

      if (!this.tickets.length) {
        // 응모권이 없습니다.
        alert(this.$t("raffle.a0005"));
        return;
      }

      // 응모하시겠습니까?
      if (confirm(this.$t("raffle.c0001").toString()) == false) {
        return;
      }

      /**
       * 응모
       * return 사용자의 래플 알림 설정 정보
       */
      axios.post("/raffle", product).then((r) => {
        if(r.data.mailingType == "01"){
          alert(this.$t("raffle.a0011"));
          return;
        }
        
        // 래플 알림 미설정
        if(r.data.mailingType == "02" && confirm(this.$t("raffle.c0004").toString()) == true){
            // 응모완료! 매일 12시 래플 알림을 설정하세요
            // 알림 설정 화면으로 이동
            this.$router.push({ name: "MypageProfile" });
            return;
        }

        this.searchProduct();
      });
    });
  }

  // firebase 다이나믹 링크
  async createDynamicLinks(): Promise<string> {
    if (this.dynamicLinksRaw) {
      return this.dynamicLinksRaw;
    }
    return await axios.get("/common/dynamic-links", { params: { link: `${this.sharedUrl}` } }).then((r) => {
      this.dynamicLinksRaw = r.data.shortLink;
      return r.data.shortLink;
    });
  }

  // SNS 공유
  sharedProductUrlToSns(platform: string) {
    if (!this.raffle) {
      // 진행 또는 예정 중인 래플이 존재하지 않습니다.
      alert(this.$t("raffle.a0009"));
      return;
    }

    if (!this.raffle.memCd) {
      // 로그인이 필요함
      alert(this.$t("common.a0003"));

      this.$router.push({ name: "Login", params: { toName: "Raffles" } });
      return;
    }

    // FIXME  추천정보이기 때문에 다이나믹 링크만 허용
    //        일반 URL로 보내면 추천인정보로 장난질 칠까봐
    this.createDynamicLinks().then((dynamicLinks) => {
      switch (platform) {
        case "kakao": {
          const imageUrl = process.env.VUE_APP_OG_IMAGE;
          const title = process.env.VUE_APP_TITLE || "";

          (this as any).$kakao.Link.sendDefault({
            objectType: "feed",
            content: {
              title: title,
              description: "집으로 오는 면세쇼핑 지쿠",
              imageUrl: imageUrl,
              link: {
                mobileWebUrl: dynamicLinks,
                webUrl: dynamicLinks,
              },
            },
            buttons: [
              {
                title: "앱으로 보기",
                link: {
                  mobileWebUrl: dynamicLinks,
                },
              },
            ],
          });
          break;
        }
        case "facebook":
          break;
        case "instagram":
          // 공유 안되는 것 같음
          break;
        case "copy": {
          const textarea = document.createElement("textarea");
          textarea.value = dynamicLinks;
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);

          // 복사되었습니다.
          this.$toast(this.$t("product.a0001"));
          break;
        }
        default:
          break;
      }
    });

    BottomSheets.closeAll();
  }

  // 남은 시간 설정
  resetRemainingTime(): void {
    const endTime = DateTime.fromSQL(this.raffle.endDt);
    const remainingTimeDuration = endTime.diffNow();

    if (remainingTimeDuration.as("hour") > 24) {
      this.remainingTimeStatus = 1;
      this.remainingTime = `D-${Math.ceil(remainingTimeDuration.as("day"))}`;
      return;
    } else if (remainingTimeDuration.as("second") > 0) {
      this.remainingTimeStatus = 2;
      this.remainingTime = remainingTimeDuration.toFormat("hh:mm:ss");
      return;
    }

    this.remainingTimeStatus = 0;
    this.remainingTime = "00:00:00";
  }

  onImageLoaded = debounce(this.onLayoutUpdated, 200);
  onLayoutUpdated() {
    this.$nextTick().then(() => {
      this.$emit("layout-update");
    });
  }

  searchProduct() {
    axios.get("raffle/products", { params: this.searchParams }).then((r) => {
      this.products = r.data.products;
      this.tickets = r.data.tickets;
      this.$nextTick().then(() => {
          window.scrollTo(0, (this.$refs.btnFriend as HTMLButtonElement).offsetTop);
      });         
    });
  }

  created() {
    axios.get("/raffle").then((r) => {
      this.raffle = r.data.raffle;
      this.products = r.data.products;
      this.tickets = r.data.tickets;
      this.myMemCd = r.data.myMemCd;
      this.raffleNotificationState = r.data.raffleNotificationState;

      if (this.viewType == "04") {
        this.searchProduct();
      }
      if (!this.raffle) {
        return;
      }
      // 파라미터 기본값 세팅
      this.searchParams.raffleCd = this.raffle.raffleCd;
      // 진행중 이벤트 아니면?
      if (this.raffle.isCurrentRaffle == false) {
        this.searchParams.searchViewType = "03";
      }

      // 남은 시간
      this.remainingTimeInterval = setInterval(() => {
        this.resetRemainingTime();
      }, 1000);
    });
  }

  beforeDestory() {
    // 남은 시간
    clearInterval(this.remainingTimeInterval);
  }
}
